module.exports = __webpack_public_path__ + "img/step_cright_img03.67169014.png";